import { component } from 'knockout-decorators'

import source from './template.html?raw'

import ErrorIcon from '../../../images/status-error.svg?url'
import ExpiredIcon from '../../../images/status-expired.svg?url'
import LockedIcon from '../../../images/status-locked.svg?url'
import WaitingIcon from '../../../images/status-waiting.svg?url'

export type IconTypes = 'error' | 'expired' | 'locked' | 'waiting'

@component('cart-error-content', source)
export class CartModalExpirationContent {
  private icons: Record<IconTypes, string> = {
    error: ErrorIcon,
    expired: ExpiredIcon,
    locked: LockedIcon,
    waiting: WaitingIcon,
  }

  constructor(private options: { message: string; icon: IconTypes }) {}
}
